module.exports = __webpack_public_path__ + "img/desc_bottom_tz3620.0d14e2e2.png";